import { render } from "./indicators_use_tab.vue?vue&type=template&id=d230112e"
import script from "./indicators_use_tab.vue?vue&type=script&lang=js"
export * from "./indicators_use_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__